module.exports = __webpack_public_path__ + "img/generate.e907ec3e.svg";